import Meta from '@/components/common/Meta'

import StorageCostEstimatePage from '@/v2/components/pages/landing-pages/storage-cost-estimate-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/storage-cost-estimate-page'

interface StorageCostEstimatePageProps {}

const Page: React.FC<StorageCostEstimatePageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.storage_cost_estimate.title ?? LANDING_PAGES_META_CONTENTS.default?.title ?? ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.storage_cost_estimate?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.storage_cost_estimate?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <StorageCostEstimatePage />
    </>
  )
}

export default Page
